<template>

<v-card outlined>
  <v-card-title>Variabilität der Sprichwörter (Ratio-Gruppen)</v-card-title>
   <v-card-subtitle>Sprichwörter sind nach dem Wert 'Ratio (eng/weit)' in Gruppen zusammengefasst, die mit Balken visualisiert werden. Dieser Wert errechnet sich aus der Frequenz für die enge Suchanfrage geteilt durch die Frequenz für die weite Suchanfrage mal 100. Für die Sprichwörter in der Gruppe 0-10 bedeutet das z.B., dass nur 10% oder weniger der Treffer für die weite Suchanfrage auch von der engen Suchanfrage erfasst werden - diese Sprichwörter sind also sehr variabel. 
     Der Tooltip zeigt die Liste der 
     Sprichwörter in jeder Gruppe.</v-card-subtitle>
  <v-card-text>

 <v-chart class="BarChart" 
   :option="lineOption"/> 
  </v-card-text>
</v-card>


</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DataZoomComponent
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";

use([
  CanvasRenderer,
  BarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DataZoomComponent
]);

export default {
  name: "SpruchHistogramm",
  props: ['spruchdata'],
   components: {
    VChart
  },
  provide: {
    [THEME_KEY]: "light"
  },

   data() {
    return {
        
        //mydata: [["Klein, aber fein", 26.47, 1], ["Viel Lärm um Nichts", 94.75, 2], ["Weniger ist mehr", 52.04, 3], ["Der Schein trügt", 66.2, 2]],
        //mydata: [[26.47, 1, "Klein, aber fein"] , [ 94.75, 2, "Viel Lärm um Nichts"], [52.04, 3, "Weniger ist mehr"], [66.2, 2, "Der Schein trügt"]],
        //mydata: [[26.47, 1], [94.75, 2], [52.04, 3], [66.2, 2]],
        //mylabels: ["Klein, aber fein", "Viel Lärm um Nichts", "Weniger ist mehr", "Der Schein trügt"],
    };
  },
   methods: {
      
    },

    computed: {
      mydata() {
       //var bins = ["bis 10", "bis 20", "bis 30", "bis 40", "bis 50", "bis 60", "bis 70", "bis 80", "bis 90", "bis 100"];
       var bins = ["0-10", "10-20", "20-30", "30-40", "40-50", "50-60", "60-70", "70-80", "80-90", "90-100"];
       var elems = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
       var surfaces = [[], [], [], [], [], [], [], [], [], []];

        for (let index = 0; index <  this.spruchdata.length; ++index) {
            const element =  this.spruchdata[index];
            if (element.ratio <= 100) {
                if (element.ratio <= 10) {
                    elems[0] += 1;
                    surfaces[0].push(element.sprichw);
                }
                else if (element.ratio <= 20) {
                    elems[1] += 1;
                    surfaces[1].push(element.sprichw);
                }
                else if (element.ratio <= 30) {
                    elems[2] += 1;
                    surfaces[2].push(element.sprichw);
                }
                else if (element.ratio <= 40) {
                    elems[3] += 1;
                    surfaces[3].push(element.sprichw);
                }
                else if (element.ratio <= 50) {
                    elems[4] += 1;
                    surfaces[4].push(element.sprichw);
                }
                else if (element.ratio <= 60) {
                    elems[5] += 1;
                    surfaces[5].push(element.sprichw);
                }
                else if (element.ratio <= 70) {
                    elems[6] += 1;
                    surfaces[6].push(element.sprichw);
                }
                else if (element.ratio <= 80) {
                    elems[7] += 1;
                    surfaces[7].push(element.sprichw);
                }
                else if (element.ratio <= 90) {
                    elems[8] += 1;
                    surfaces[8].push(element.sprichw);
                }
                else if (element.ratio <= 100) {
                    elems[9] += 1;
                    surfaces[9].push(element.sprichw);
                }
            }
        }

        var items = []
        var colors = ["black", "rgb(33, 33, 33)", "rgb(66, 66, 66)", "rgb(97, 97, 97)", "rgb(117, 117, 117)", "rgb(158, 158, 158)", 
        "rgb(189, 189, 189)", "rgb(224, 224, 224)", "rgb(238, 238, 238)", "rgb(245, 245, 245)"]
        colors.reverse();
        for (let i=0; i<elems.length; i++) {
            items.push({value: elems[i], itemStyle: {color: colors[i]}});
        }

       var result = {"elemCounts":items, "bins":bins, "labels":surfaces};
       console.log(result);
       return result;
      },

        
      lineOption() {
        var labels = this.mydata.labels;

        var option = {
            tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    },
    formatter: function (params) {
      var index = params[0].dataIndex;
      console.log(labels);
      return labels[index].join("<br>");
    }
  },

  yAxis: {
    type: "value",
    nameLocation: 'middle',
    nameGap: 30,
    name: "Anzahl Sprichwörter"
  },
  xAxis: {
    type: "category",
    data: this.mydata.bins,
    nameLocation: 'middle',
    nameGap: 30,
    name: "sehr variabel <------> sehr fest (Ratio eng/weit)"
  },
  
  grid: {
    left: 40,
    right: 130
  },
  series: [
    {
      data: this.mydata.elemCounts,
      type: 'bar',
      emphasis: {
        focus: 'self'
      },
      label: {
        show: true,
        position: 'inside'
      },
    }
  ]
        }
    
    return option;
      }
    }
};
</script>

<style scoped>
.BarChart {
  height: 500px;
  width: 1000px;
}
</style>